import { defineStore } from 'pinia'
import { ref } from '@nuxtjs/composition-api'

export const usePrivacyPolicyModel = defineStore('privacyPolicy', () => {
  const status = ref(true)

  return {
    status
  }
})
